import withStyles from '@material-ui/core/styles/withStyles';
import { withSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { withRouter } from "react-router-dom";
import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import emptylist from "../../../../../../Assets/Svg/illustration-no-policy.svg";

class Policy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div className="content-outer-wrapper">
                <Grid container className="height100">
                    <Grid item xs={12} md={12} sm={12}>
                        <div className="display-table height100 width100">
                            <div className="display-table-cell vertical-middle">
                                <div className="text-center">
                                    <img src={emptylist} width="25%"></img>
                                </div>
                                <div className="page-header-name text-center">There are no policies to display yet!</div>
                                <div className="page-subheader-name text-center">Create your first policy to get started</div>
                                <div className="text-center">
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        style={{ width: 140 }}
                                        onClick={this.props.onCreate}
                                    >
                                        Create
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

Policy.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    });

const mapDispatchToProps = (dispatch) => bindActionCreators({
    }, dispatch);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles()(withSnackbar(Policy))));
